import classNames from "classnames";
import React, { useState } from "react";
import PhotoBox from "../PhotoBox/PhotoBox";
import UnsplashAttribution from "../UnsplashAttribution";
import { UnstyledButton } from "../Buttons";
import { IImageBlockImage } from "./imageBlockContent";
import "./UberContentImages.scss";

interface IProps {
    images: IImageBlockImage[];
    disableClick?: boolean;
}

const UberContentImages = (props: IProps) => {
    const [openIndex, setOpenIndex] = useState<number | undefined>(undefined);
    const columnCount = Math.min(props.images.length, 3);

    return (
        <div className={classNames("UberContentImages", "column-count-" + columnCount)}>
            {props.images.map((image: IImageBlockImage, index: number) => (
                <div className="UberContentImages-item" key={index}>
                    {props.disableClick ? (
                        <img src={image.content} alt="" loading="lazy" />
                    ) : (
                        <UnstyledButton className="UberContentImages-button" onClick={() => setOpenIndex(index)}>
                            <img src={image.content} alt="" loading="lazy" />
                        </UnstyledButton>
                    )}
                    {!!image.externalAuthorName && (
                        <UnsplashAttribution
                            authorName={image.externalAuthorName}
                            authorUrl={image.externalAuthorUrl}
                        />
                    )}
                </div>
            ))}
            {openIndex !== undefined && (
                <PhotoBox
                    imageUrls={props.images.map((image: IImageBlockImage) => image.content)}
                    initialIndex={openIndex}
                    onClose={() => setOpenIndex(undefined)}
                />
            )}
        </div>
    );
};

export default UberContentImages;
